import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  Button,
  Grid,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import StepCircle from "../StepCircle";
import api from "../../api";

const steps = ["Datos del Consumo", "Asignar Vehículo"];

const EditarCombustible = ({ combustible, handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [vehiculos, setVehiculos] = useState([]);
  const [conductores, setConductores] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  const [formData, setFormData] = useState({
    producto: "",
    litros_unidades: "",
    fecha_y_hora: "",
    domicilio: "",
    localidad: "",
    provincia: "",
    vehiculo: "",
    conductor: "",
    imp_tot_yer: "",
  });

  useEffect(() => {
    api.get("vehiculos/").then((res) => setVehiculos(res.data));
    api.get("conductores/").then((res) => setConductores(res.data));
  }, []);

  useEffect(() => {
    if (combustible) {
      setFormData({
        producto: combustible.producto || "",
        litros_unidades: combustible.litros_unidades || "",
        fecha_y_hora: combustible.fecha_y_hora ? combustible.fecha_y_hora.slice(0, 16) : "",
        domicilio: combustible.domicilio || "",
        localidad: combustible.localidad || "",
        provincia: combustible.provincia || "",
        vehiculo: combustible.vehiculo || "",
        conductor: combustible.conductor || "",
        imp_tot_yer: combustible.imp_tot_yer || "",
      });
    }
  }, [combustible]);

  useEffect(() => {
    const {
      producto,
      litros_unidades,
      fecha_y_hora,
      domicilio,
      localidad,
      provincia,
      imp_tot_yer,
    } = formData;
    setIsStep1Valid(
      producto && litros_unidades && fecha_y_hora && domicilio && localidad && provincia && imp_tot_yer
    );
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .put(`combustibles/${combustible.id}/`, formData)
      .then((res) => {
        alert("Registro de consumo actualizado correctamente.");
        if (onUpdate) {
          onUpdate(res.data); // send the new data to parent
        }
        handleClose();
      })
      .catch((err) => {
        console.error(err);
        alert("Hubo un error al actualizar el registro.");
      });
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Editar Registro de Consumo
      </Typography>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <TextField
              label="Producto"
              name="producto"
              value={formData.producto}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Litros Cargados"
              name="litros_unidades"
              type="number"
              value={formData.litros_unidades}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Fecha y Hora"
              name="fecha_y_hora"
              type="datetime-local"
              value={formData.fecha_y_hora}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Domicilio"
              name="domicilio"
              value={formData.domicilio}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Localidad"
              name="localidad"
              value={formData.localidad}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Provincia"
              name="provincia"
              value={formData.provincia}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Importe Total (ARS)"
              name="imp_tot_yer"
              type="number"
              value={formData.imp_tot_yer}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleNext}
              disabled={!isStep1Valid}
              sx={{ background: "#152d51" }}
            >
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Vehículo</InputLabel>
              <Select name="vehiculo" value={formData.vehiculo} onChange={handleChange}>
                <MenuItem value="">Sin asignar</MenuItem>
                {vehiculos.map((v) => (
                  <MenuItem key={v.id} value={v.id}>
                    {v.patente} - {v.marca} {v.modelo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Conductor</InputLabel>
              <Select name="conductor" value={formData.conductor} onChange={handleChange}>
                <MenuItem value="">Sin asignar</MenuItem>
                {conductores.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.nombre} {c.apellido}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ background: "#152d51" }}>
              Guardar Cambios
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default EditarCombustible;
